"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/**
 * 季度选择框
 */
var _default = exports.default = {
  name: 'FormQuarterPicker',
  props: {
    val: {
      type: [String, Number, Boolean, Array, Object, Date],
      default: ''
    },
    // 编辑模式 view edit
    mode: {
      type: String,
      default: 'edit'
    },
    // 禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // placeholder
    placeholder: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      inputVal: this.val,
      options: [],
      labelKey: 'name',
      valueKey: 'code'
    };
  },
  computed: {
    isDisabled: function isDisabled() {
      return this.mode === 'view' || this.disabled;
    },
    placeholderTxt: function placeholderTxt() {
      var txt = '';
      if (this.placeholder) {
        txt = this.placeholder;
      } else {
        txt = this.$t('common.pleaseSelectOrInput');
      }
      return this.isDisabled ? '' : txt;
    }
  },
  watch: {
    val: {
      deep: true,
      immediate: true,
      handler: function handler(newVal) {
        this.inputVal = newVal;
      }
    }
  },
  mounted: function mounted() {
    this.initOptions();
  },
  methods: {
    // 初始化年付+季度下拉框
    // 目前初始化 2000 - 2039年
    initOptions: function initOptions() {
      var arr = [];
      var i = 2000;
      while (i < 2040) {
        arr.push({
          name: "".concat(i, "Q1"),
          code: "".concat(i, "01")
        });
        arr.push({
          name: "".concat(i, "Q2"),
          code: "".concat(i, "02")
        });
        arr.push({
          name: "".concat(i, "Q3"),
          code: "".concat(i, "03")
        });
        arr.push({
          name: "".concat(i, "Q4"),
          code: "".concat(i, "04")
        });
        i++;
      }
      this.options = [].concat(arr);
    },
    onChange: function onChange(val) {
      if (this.isDisabled) {
        return false;
      }
      this.$emit('update:val', val);
    }
  }
};